module.exports = __webpack_public_path__ + "img/fuel-insight-loading.b2b30303.svg";